// extracted by mini-css-extract-plugin
module.exports = {"w1pdv1kl":"w1pdv1kl","r1t5pwgv":"r1t5pwgv"};